export class DetectedFacesFilter {
  id?: number
  cameraId?: Array<number> | number
  cameraClientId?: Array<number> | number
  companyId?: Array<number> | number
  listId?: Array<number> | number
  listName?: Array<string>
  faceId?: Array<number>
  faceName?: Array<string> | string | null
  cameraName?: Array<string> | string
  clientName?: Array<string> | string

  constructor(data: DetectedFacesFilter) {
    if (data.id) this.id = data.id
    if (data.cameraId || (Array.isArray(data.cameraId) && data.cameraId.length)) this.cameraId = data.cameraId
    if (data.cameraClientId || (Array.isArray(data.cameraClientId) && data.cameraClientId.length)) this.cameraClientId = data.cameraClientId
    if (data.companyId || (Array.isArray(data.companyId) && data.companyId.length)) this.companyId = data.companyId
    if (data.listId || (Array.isArray(data.listId) && data.listId.length)) this.listId = data.listId
    if (data.faceName !== undefined && (Array.isArray(data.faceName) ? !!data.faceName.length : true)) this.faceName = data.faceName
    if (data.cameraName || (Array.isArray(data.cameraName) && data.cameraName.length)) this.cameraName = data.cameraName
    if (data.clientName || (Array.isArray(data.clientName) && data.clientName.length)) this.clientName = data.clientName
    if (data.listName && data.listName.length) this.listName = data.listName
    if (data.faceId && data.faceId.length) this.faceId = data.faceId
  }
}
